import { detect } from 'detect-browser';
import { MediaPlayer } from '../../../classes/media/player/MediaPlayer';
import { Media } from '../../../classes/media/Media';
export class DeferClasses {
    MediaPlayer = MediaPlayer;
    Media = Media;
    detectBrowser = detect;
}
